module.exports = __webpack_public_path__ + "img/arrow.fc8a2bba.svg";